/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentWithPSPTransaction
 */
export interface PaymentWithPSPTransaction {
    /**
     * 
     * @type {string}
     * @memberof PaymentWithPSPTransaction
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentWithPSPTransaction
     */
    externalPaymentReference?: string;
}

/**
 * Check if a given object implements the PaymentWithPSPTransaction interface.
 */
export function instanceOfPaymentWithPSPTransaction(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaymentWithPSPTransactionFromJSON(json: any): PaymentWithPSPTransaction {
    return PaymentWithPSPTransactionFromJSONTyped(json, false);
}

export function PaymentWithPSPTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentWithPSPTransaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentMethodId': !exists(json, 'paymentMethodId') ? undefined : json['paymentMethodId'],
        'externalPaymentReference': !exists(json, 'externalPaymentReference') ? undefined : json['externalPaymentReference'],
    };
}

export function PaymentWithPSPTransactionToJSON(value?: PaymentWithPSPTransaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentMethodId': value.paymentMethodId,
        'externalPaymentReference': value.externalPaymentReference,
    };
}

